// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1BGtP","paramInput":"JobSimulator_paramInput__2g-Mz","input":"JobSimulator_input__17Y0A"};